"use strict";
module.exports = {
    ADD_CLAIM: '/claims/add/:itemId',
    AGR: '/agr',
    CHANGE_EXCESS: '/policy/change-excess',
    CHANGE_PASSWORD: '/settings/change-password',
    CHANGE_YOUR_COVER: '/policy/change',
    CHANGE_YOUR_COVER_COMPARE: '/policy/change/compare/:productType',
    CHANGE_YOUR_COVER_CONFIRM: '/policy/change/confirm',
    CHANGE_YOUR_COVER_CONTACT_US: '/policy/change/contact-us',
    CHANGE_YOUR_COVER_NOT_SUPPORTED: '/policy/change-not-supported',
    CHANGE_YOUR_COVER_PRESELECTED_PRODUCT: '/policy/change/product/:productId',
    CHANGE_YOUR_COVER_PRODUCT: '/policy/change/product',
    CHANGE_YOUR_COVER_SUMMARY: '/policy/change/summary',
    CLAIMS: '/claims',
    CLAIMS_AMBULANCE: '/claims/ambulance',
    CLAIMS_CALCULATOR: '/calculator',
    CLAIMS_HELP: '/claims/help',
    CLAIMS_HISTORY: '/claims',
    CLAIMS_HOSPITAL_AMBULANCE: '/claims/hospital-ambulance',
    CLAIMS_PAYMENTS: '/claims/payments',
    CLAIM_DETAIL: '/claims/history/:claimId',
    COMMUNICATION_PREFERENCES: '/settings/communication-preferences',
    DOCUMENTS: '/documents',
    DOCUMENTS_UPLOAD: '/documents/upload',
    DOCUMENTS_UPLOAD_WITH_TYPE: '/documents/upload/type/:type',
    EDIT_MEMBER: '/settings/edit-member/:memberId',
    EDIT_POLICY_HOLDER: '/settings/edit-policy-holder',
    EDIT_POLICY_MAKE_A_PAYMENT: '/settings/make-a-payment',
    ERROR_404: '/404',
    ERROR_500: '/500',
    FIND_A_PROVIDER: '/find-a-provider',
    HOME: '/',
    HOSPITAL_COVER_CHECK: '/hospital-cover-check',
    HOSPITAL_COVER_CHECK_NOT_SUPPORTED: '/hospital-cover-check-not-supported',
    HOSPITAL_COVER_CHECK_OUTCOME: '/hospital-cover-check/outcome',
    JOINT_CLAIMS: '/joint-claims',
    LIMITS: '/policy/limits',
    LOGGED_OUT_PAYMENTS: '/pay',
    LOGGED_OUT_PAYMENTS_CARD_DETAILS: '/pay/card-details',
    LOGGED_OUT_PAYMENTS_SUCCESS: '/pay/success',
    LOGIN: '/',
    LOGOUT: '/logout',
    MAKE_A_PAYMENT: '/payments/make-a-payment',
    MEMBER_NUMBER_RECOVERY: '/forgot-member-number',
    OFFERS_HOME: '/offers',
    OFFERS_HOYTS: '/offers/hoyts',
    OFFERS_PICKLEBALL: '/offers/pickleball',
    PASSWORD_RECOVERY: '/recovery',
    PASSWORD_RECOVERY_CONFIRM: '/recovery-confirm',
    PASSWORD_RECOVERY_SECURITY_CODE: '/recovery-security-code',
    PAUSE_COVER: '/settings/pause-cover',
    PAUSE_COVER_EDIT: '/settings/pause-cover/edit',
    PAUSE_COVER_OVERSEAS: '/settings/pause-cover/overseas',
    PAUSE_COVER_RESTART: '/settings/pause-cover/restart',
    PAUSE_COVER_REVIEW: '/settings/pause-cover/review',
    PAYMENTS: '/payments',
    PAYMENT_DETAILS: '/payments/details',
    PAYMENT_METHOD: '/payments/method',
    PAYMENT_SET_UP_DIRECT_DEBIT_AGREEMENT: '/payments/set-up-direct-debit-agreement',
    PICC: '/personal-info-claims-consent',
    PICC_ADDITIONAL_INFO: '/personal-info-claims-consent/additional-info',
    PICC_CONSENT: '/personal-info-claims-consent/consent',
    PICC_SUCCESS: '/personal-info-claims-consent/success',
    PICC_UPDATE_MEMBER: '/consent/update-member',
    PICC_VALIDATE_COINSURED: '/consent/validate-coinsured',
    PICC_VALIDATE_MEMBER: '/consent/validate-member',
    REFER_A_FRIEND: '/settings/refer',
    REGISTRATION: '/register',
    REGISTRATION_CONFIRM: '/register-confirm',
    REPLACEMENT_CARD: '/settings/replacement-card',
    REVIEW_POLICY_DETAILS: '/settings/edit-policy-holder/review',
    SETTINGS: '/settings',
    SET_PASSWORD: '/set-password',
    UPDATE_AGR: '/update-agr',
    WAITING_PERIODS: '/policy/waiting-periods',
    YOUR_COVER: '/policy',
};
